module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq27-88f22a5c64e9955575129e85c8b4dc46.jpg";